<template>
  <div class="operation-box">
    <div class="add">
      <span>{{ title.replace("柜", "表") }}({{ data.length }})</span>
      <i class="iconfont icon-jia" @click="showAddInputHandle"></i>
      <!-- {{showEditInputIndex}}-----{{showAddInput}} -->
    </div>
    <ul>
      <div class="yibiao-title">
        <span class="txt-gray fs14">现场编号</span
        ><span class="txt-gray fs14">设备编号</span>
      </div>
      <li v-if="showAddInput" @keyup.enter="addThis">
        <input
          type="text"
          ref="addInput"
          v-model="input"
          maxlength="10"
          placeholder="现场编号"
          @keyup="input = input.replace(/\s+/g, '')"
        />
        <div class="tag-title small-tag" v-if="showIndex">{{ id }}_</div>
        <input
          type="text"
          :class="showIndex ? 'tag-input' : ''"
          class="tag-small-input"
          maxlength="10"
          v-model="equipmentCode"
          placeholder="设备编号"
          @keyup="equipmentCode = equipmentCode.replace(/\s+/g, '')"
        />
        <div class="icon-box">
          <i @mousedown="isShow()" class="iconfont icon-close"></i>
          <i class="iconfont icon-huiche" @mousedown="addThis"></i>
        </div>
      </li>
      <li
        v-for="(item2, index2) in data"
        :key="index2 + 'b'"
        @keyup.enter="addThis2(item2.id)"
      >
        <span v-if="showEditInputIndex != index2" :title="item2.localeNumber">{{
          ellipsis(item2.localeNumber)
        }}</span>
        <span
          v-if="showEditInputIndex != index2"
          :title="item2.equipmentCode"
          >{{ ellipsis(item2.equipmentCode) }}</span
        >
        <!-- v-if="showEditInputIndex === index2"  @blur="showEditInputIndex = -1"-->
        <input
          v-if="showEditInputIndex === index2"
          maxlength="10"
          type="text"
          ref="editInput"
          v-model="input"
          @keyup="input = input.replace(/\s+/g, '')"
        />
        <input
          v-if="showEditInputIndex === index2"
          maxlength="10"
          readonly
          type="text"
          ref="editInput1"
          v-model="equipmentCode"
          @keyup="equipmentCode = equipmentCode.replace(/\s+/g, '')"
        />
        <div class="icon-box">
          <i
            v-if="showEditInputIndex != index2"
            class="iconfont icon-bianji2"
            @mousedown="
              showEditInputHandle(
                index2,
                item2.localeNumber,
                item2.equipmentCode
              )
            "
          ></i>
          <i
            v-if="showEditInputIndex != index2"
            @mousedown="deleteThis(item2.id)"
            class="iconfont icon-close"
          ></i>
          <i
            v-if="showEditInputIndex === index2"
            @mousedown="isEditShow"
            class="iconfont icon-close"
          ></i>
          <i
            v-if="showEditInputIndex == index2"
            class="iconfont icon-huiche"
            @mousedown="addThis2(item2.id)"
          ></i>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>

import {
  Message
} from 'element-ui';
export default {
  props: [
    "title",
    "data",
    "type",
    "rootData",
    "rightIndexId",
    "state",
    "showIndex",
  ],
  data() {
    return {
      input: "",
      equipmentCode: "",
      // 添加的显示状态
      showAddInput: false,
      // 编辑的状态
      showEditInputIndex: -1,
      id: "",
    };
  },
  created() {
    this.id = this.$route.params.id;
  },
  methods: {
    // 添加1
    showAddInputHandle() {
      this.state = true;
      this.$emit("toState", this.state);
      if (this.showEditInputIndex === 0) {
        Message("请先完成上一步操作");
      } else {
        this.input = "";
        this.equipmentCode = "";
        this.showAddInput = true;
        this.$nextTick(() => {
          this.$refs.addInput.focus();
        });
      }
    },
    showEditInputHandle(i, name, equipmentCode) {
      this.state = true;
      this.$emit("toState", this.state);
      if (this.showAddInput) {
        Message("请先完成上一步操作");
      } else {
        this.input = name;
        this.equipmentCode = equipmentCode;
        this.showEditInputIndex = i;

        setTimeout(() => {
          this.$nextTick(() => {
            this.$refs.editInput[0].focus();
          });
        }, 0);
      }
    },
    isShow() {
      this.showAddInput = false;
      this.input = "";
      this.equipmentCode = "";
    },
    isEditShow() {
      this.showEditInputIndex = -1;
    },
    // 添加1
    addThis(val, index) {
      if (!this.input || !this.equipmentCode) {
        Message("请输入内容后再操作");
        return;
      }
      console.log(val);
      this.$emit("addItem", this.type, this.input, this.equipmentCode);
      this.$forceUpdate();
      this.input = "";
      this.equipmentCode = "";
      this.showAddInput = false;
    },
    // 编辑
    addThis2(id) {
      if (!this.input) {
        Message("请输入内容后再操作");
        return;
      }
      this.$emit("upItem", this.type, id, this.input);
      this.$forceUpdate();
      this.input = "";
      this.showEditInputIndex = -1;
    },
    deleteThis(id) {
      this.$emit("deleteItem", this.type, id);
    },
    ellipsis(title) {
      if (title) {
        if (title.length <= 5) {
          return title;
        } else {
          return title.substring(0, 5) + "...";
        }
      } else {
        return title;
      }
    },
  },
  watch: {
    state(v) {
      if (!v) {
        this.showAddInput = false;
        // 编辑的状态
        this.showEditInputIndex = -1;
      }
    },
  },
};
</script>

<style lang="less" scoped>
.yibiao-title {
  width: 100%;
  line-height: 30px;
  span {
    display: inline-block;
    width: 50%;
  }
}
.operation-box {
  width: 100%;
  padding: 6px;
  box-sizing: border-box;
  .add {
    width: 100%;
    height: 48px;
    line-height: 48px;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid rgba(231, 231, 231, 1);
    i {
      color: rgba(158, 163, 173, 1);
      cursor: pointer;
      font-size: 18px;
    }
  }
  ul {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    align-content: flex-start;
    height: 510px;
    overflow: auto;
    li {
      width: 100%;
      height: 33px;
      line-height: 33px;
      font-size: 14px;
      color: #152139;
      outline: none;
      position: relative;
      cursor: pointer; // 修改文字样式
      span {
        width: 45%;
        height: 100%;
        text-indent: 15px;
        display: inline-block;
      }
      input {
        width: 42%;
        height: 95%;
        outline: none;
        border: none;
        font-size: 14px;
        text-indent: 15px;
        background: rgba(16, 57, 126, 0.1);
      }
      input:first-child {
        border-right: 15px solid #fff;
      }
      .icon-box {
        position: absolute;
        right: -3px;
        top: 0;
        width: 57px;
        height: 33px;
        text-align: right;
        display: none;
        background: #e7ebf2;
        .iconfont {
          margin: 0 6px;
          color: rgba(110, 123, 145, 1);
          cursor: pointer;
        }
      }
      &:hover {
        background: rgba(16, 57, 126, 0.1);
        input {
          background: #e7ebf2;
        }
        .icon-box {
          display: block;
        }
      }
      &.active {
        background: rgba(16, 57, 126, 0.1);
        input {
          background: #e7ebf2;
        }
        .icon-box {
          background: #e7ebf2;
        }
      }
    }
  }
}
</style>